/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("LogoSlider", ["jquery", "Behaviors"], factory);
    } else {
        root.LogoSlider = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    var moduleInstanceId;

    function LogoSlider(target) {
       
        //handle multiple instances in one page

        this.moduleInstanceId = '.fl-node-' + target.getAttribute( 'data-LogoSlider' );

        Behaviors.init(LogoSlider, this, arguments);

        this.element = this.$elem[0];

        this.initOwlCarousel( this.moduleInstanceId  );

    }

    Behaviors.inherit(LogoSlider, Behaviors.Behavior);

    LogoSlider.QUERY = "[data-LogoSlider]";

    LogoSlider.ELEMENTS = {
        sliderItem: " .testimonial-item",
        carousel: " .LogoSlider .owl-carousel",
    };

    LogoSlider.prototype.initOwlCarousel = function(instanceId) {
       

        if($(LogoSlider.ELEMENTS.carousel).length){


            this.carousel = $( instanceId + LogoSlider.ELEMENTS.carousel).owlCarousel({
                loop:  true,
                dots: true,
                autoplay: true,
                items: 1,
                lazyLoad: true,
                slideBy: 1,
                autoplayTimeout:8000,
                // responsive: {
                //     0:{
                //         stagePadding: 0,
                //         autoHeight: true,
                //         responsiveClass: true,
                //         items: 8
                //     },
                //     480:{
                //       items: 8
                //     },
                //     769:{
                //       items: 8,
                //       margin: 65,
                //     }
                // }
            });

        }
 
    };
    
    Behaviors.register_behavior(LogoSlider);

    module.LogoSlider = LogoSlider;

    return module;
}));
